module.exports = __webpack_public_path__ + "media/share_images/boombox-4bff7d13.svg";